interface IconProps {
	active?: boolean;
	color?: string;
}

export const International = ({ active, color }: IconProps) => (
	<svg
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		x="0px"
		y="0px"
		width="24"
		height="24"
		viewBox="0 0 24 24"
	>
		<defs>
			<filter
				id="Adobe_OpacityMaskFilter"
				filterUnits="userSpaceOnUse"
				x="5.8"
				y="8.4"
				width="15"
				height="15"
			>
				<feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
			</filter>
		</defs>
		<mask
			maskUnits="userSpaceOnUse"
			x="5.8"
			y="8.4"
			width="15"
			height="15"
			id="path-1-outside-1_12478_53449_00000106143779636159894560000017490229598678003644_"
		>
			<rect x="5.2" y="7.4" width="15" height="15" />
			<path d="M7.9,18.6c1.1,1.1,2.5,1.6,4,1.6c1.5,0,3-0.6,4-1.7c1.1-1.1,1.7-2.5,1.7-4c0-1.5-0.6-2.9-1.6-4L12,14.6L7.9,18.6z" />
		</mask>
		<path
			d="M7.9,18.6c1.1,1.1,2.5,1.6,4,1.6c1.5,0,3-0.6,4-1.7c1.1-1.1,1.7-2.5,1.7-4c0-1.5-0.6-2.9-1.6-4L12,14.6
	L7.9,18.6z"
			fill={active ? color : 'white'}
			stroke={active ? color : '#0F0F0F'}
		/>
		<polygon points="6,15.7 5,14.6 14.7,4.9 9.2,4.4 9.3,2.9 18.1,3.6 " />
	</svg>
);
